import React from "react";
import {useTranslation} from "react-i18next";
import {Checkbox, Col, Form, Modal, Row} from "antd";
import "./columns.modal.scss";

interface ColumnsModalProps {
    visible: boolean
    columns: {title: string, key: string}[],
    selectedColumns: string[],
    selectColumns: (values: {columns: string[]}) => void,
    onClose: () => void
    hiddenColumns?: string[]
}

export const ColumnsModal: React.FC<ColumnsModalProps> = ({columns, visible, selectedColumns, selectColumns, onClose, hiddenColumns = []}) => {
    const {t} = useTranslation("translation", {useSuspense: false});
    const [form] = Form.useForm();

    return (
        <Modal
            visible={visible}
            maskClosable={false}
            title={t("TABLE_SETTINGS")}
            okText={t("SAVE")}
            cancelText={t("CANCEL")}
            onOk={() => form.submit()}
            onCancel={() => {
                onClose();
                form.resetFields();
            }}
        >
            <Form
                form={form}
                layout="vertical"
                name={"accounts_form"}
                initialValues={{columns: selectedColumns.filter(item => item !== "action" || !hiddenColumns?.includes(item))}}
                onFinish={() => form
                    .validateFields()
                    .then(values => {
                        selectColumns(values)
                        onClose();
                    })
                }
            >
                <Row gutter={10}>
                    <Col span={24}>
                        <Form.Item
                            name="columns"
                            label={t("COLUMNS")}
                            rules={[{
                                required: true,
                                message: t("FROM.ERROR.PLEASE_SELECT_VALUE"),
                                validator: async (rule, columns) => {
                                    try {
                                        if (!columns || columns.length === 0) {
                                            return Promise.reject((t('FROM.ERROR.PLEASE_ADD_VALUE')));

                                        }
                                    } catch (error) {
                                        throw new Error(String(error));
                                    }
                                }
                            }]}
                        >
                            <Checkbox.Group className={"columns-modal-group"}>
                                {columns.map(item => (
                                    <Checkbox className={"columns-modal-checkbox"} key={item.key} value={item.key}>{t(item.title)}</Checkbox>
                                ))}
                            </Checkbox.Group>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
}